import PageFooter from './page-footer';
import PageHeader from './page-header';

export { PageFooter, PageHeader };
